export default __webpack_public_path__ + "static/media/Background 5_00061.274c4172.png";